<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent icono-titulo="fas fa-boxes" texto-titulo="Aumento general"></TituloComponent>
    <div class="main-card mb-3 card col-12">
      <div class="card-body">
        <form @submit.prevent="guardarArticulo()">
          <div class="row">
            <FloatLabel label="Porcentaje de aumento:" clase="offset-md-3  col-md-6 col-12" append="%">
              <input
                v-model="porcentaje_aumento"
                id="porcentaje_aumento"
                inputmode="numeric"
                placeholder="0.00"
                type="text"
                class="form-control"
                :class="(enviado && (!$v.porcentaje_aumento.required || !$v.porcentaje_aumento.decimal)) ? 'is-invalid' : ''"
              />
            </FloatLabel>
          </div>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import TituloComponent from "@/components/layouts/TituloComponent.vue";
import FloatLabel from "@/components/layouts/FloatLabel.vue";
import BlockUI from "@/components/loaders/BlockUI.vue";
import {decimal, required} from "vuelidate/lib/validators";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "AumentoGeneral",
  components: {
    TituloComponent,
    FloatLabel,
    BlockUI,
  },
  data() {
    return {
      porcentaje_aumento: null,
      loading: false,
      enviado: false,
    };
  },
  validations: {
    porcentaje_aumento: {required, decimal},
  },
  methods: {
    guardarArticulo() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .put("/articulos/aumento-general", {aumento: this.porcentaje_aumento})
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `Se aplicó el aumento con éxito.`,
            });
            this.enviado = false;
            this.$router.push({name: 'ListarArticulos'})
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
}
</script>

<style scoped>

</style>
